<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{$t('str.news')}}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">{{$t('str.keyword')}}</b-col>
                    <b-col sm="8"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-input id="keyword" type="text" name="keyword" :placeholder="$t('str.search')"
                        v-model="keyword" @keyup.enter="getData()"></b-form-input>
                    </b-col>
                    <b-col sm="4"></b-col>
                    <b-col sm="4">
                      <buttons style="float:right;" button-type="search" @click="getData()" />&nbsp;
                      <buttons style="float:right;" button-type="reset_filter" @click="resetFilter()" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">{{$t('str.category')}}</b-col>
                    <b-col sm="4">{{$t('str.country')}}</b-col>
                    <b-col sm="4">
                      <router-link style="float:right;" to="/office/news/manage/0" class="btn-setting">
                        <buttons button-type="add_new" />
                      </router-link>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-select name="category" v-model="categoryId" @change="setCategoryId">
                        <option :value="null">{{ $t('str.all-category') }}</option>
                        <option v-for="(cat, i) in categorySelect" :value="cat.value" :key="i">{{cat.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="4">
                      <b-form-select id="country_id" name="country_id" :plain="true" v-model="country_id"
                        style="height:100%;">
                        <option value="">{{$t('str.all')}}</option>
                        <option v-for="(c, index) in countrySelect" :value="c.value" :key="index">{{c.text}}
                        </option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="4"></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center':true, 'd-none':items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none':!items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="created_at" slot-scope="data">
              {{ data.item.created_at | moment('from', 'now') }}
            </template>
            <template slot="updated_at" slot-scope="data">
              {{ data.item.updated_at | moment('from', 'now') }}
            </template>
            <template slot="action" slot-scope="data">
              <router-link :to="'/office/news/manage/'+data.item.id">
                <buttons button-type="edit" />
              </router-link>
              <buttons button-type="toggle" :toggle="data.item.is_published" toggleClassIcon="fa-bell-o"
                toggleTrueStr="str.unpublish" toggleFalseStr="str.publish" @click="toggleForumAccess(data.item.id)" />
              <buttons button-type="broadcast" @click="confirmBroadcast(data.item.id)" />
              <buttons button-type="delete" @click="confirmDelete(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none':!items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-delete-modal :item="confirmDeleteId" @confirm="deleteNews" @cancel="cancelDelete"></confirm-delete-modal>
    <confirm-broadcast-modal :item="confirmBroadcastId" @confirm="broadcastNews" @cancel="cancelBroadcast">
    </confirm-broadcast-modal>
  </div>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import ConfirmBroadcastModal from '@/views/component/ConfirmBroadcastModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'News',
  components: {
    'paging': Pagination,
    'confirm-delete-modal': ConfirmModal,
    'confirm-broadcast-modal': ConfirmBroadcastModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'title_en', label: 'Title', sortable: true },
        { key: 'countries', sortable: true },
        { key: 'created_at', sortable: true },
        { key: 'updated_at', sortable: true },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmModal: false,
      confirmBroadcastModal: false,
      confirmDeleteId: '',
      confirmBroadcastId: '',
      categoryId: null,
      categoryList: [],
      categorySelect: [],
      country_id: 0,
      countrySelect: [],
      office_id: 0,
      officeSelect: [],
    }
  },
  methods: {
    async getCountrySelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/News/Country`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.countrySelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.officeSelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getNewsCategorySelect() {
      this.$auth.checkSession()
      try {
        var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/NewsCategory`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.categoryList = getData.data.data
        let catData = JSON.parse(JSON.stringify(this.categoryList))

        for (let i = 0; i < catData.length; i++) {
          this.categorySelect.push({ 'value': catData[i].id, 'text': catData[i].name_en })
        }
      } catch (e) {
        console.log(e)
      }
    },
    setCategoryId(val) {
      this.categoryId = val
      this.getData()
    },
    async getData(page) {
      this.$auth.checkSession()

      let officerOffice = this.$auth.session.get('office')
      if (officerOffice) this.office_id = officerOffice

      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.categoryId != null) trail = `${trail}&category=${this.categoryId}`
      if (this.country_id != '') trail += `&country_id=${this.country_id}`
      if (this.office_id != '') trail += `&office_id=${this.office_id}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/News${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async deleteNews(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/News/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getData()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    async toggleIsPublished(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.post(`${this.$helper.envi.VUE_APP_API_URL}/News/TogglePublish`,
          { id: id },
          {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getData()
      } catch (e) {
        console.log(e.response)
      }
    },
    async broadcastNews(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.post(`${this.$helper.envi.VUE_APP_API_URL}/News/Broadcast`,
          { id: id },
          {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.confirmBroadcastModal = false
      } catch (e) {
        if (e.response.status == 555)
          this.$toast.error(e.response.data, '', {
            position: 'topCenter'
          })
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.country_id = 0
      this.office_id = 0
      this.getNewsCategorySelect()
      this.getData()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getData(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModal = false
    },
    confirmBroadcast(id) {
      this.$auth.checkSession()
      this.confirmBroadcastModal = true
      this.confirmBroadcastId = id
    },
    cancelBroadcast() {
      this.$auth.checkSession()
      this.confirmBroadcastModal = false
    }
  },
  created() {
    this.getCountrySelect()
    this.getOfficeSelect()
    this.getNewsCategorySelect()
    this.getData()
  }
}
</script>